import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TimeNavigationService {

  constructor() {}

  setTime(componentName: string, time: Date) {
    sessionStorage.setItem(componentName, JSON.stringify(time));
  }

  getTime(componentName: string): Date | null {
    const time = sessionStorage.getItem(componentName);
    return time ? new Date(JSON.parse(time)) : null;
  }
}
